import React from "react";
import PropTypes from "prop-types";
import { translate } from "@td/shared_utils";
import { participantTypes } from "../../constants";

const ParticipantItem = ({
  participantId,
  participantType,
  participant,
  onDelete,
}) => (
  <tr>
    <td data-testid="participant-item-name">
      {participantType === participantTypes.PROVIDER ? (
        <a href={window.Routes.provider_path(participantId)}>
          {participant.firstAndLastName}
        </a>
      ) : (
        <React.Fragment>
          {participant.firstAndLastName}
        </React.Fragment>
      )}
    </td>
    <td data-testid="participant-item-id">
      {participantId}
    </td>
    <td data-testid="participant-item-type">
      {participantType}

      {participantType === participantTypes.ADMIN && (
        <a
          className="delete"
          onClick={() => onDelete(participantId)}
          data-testid="participant-delete-action"
        >
          {translate(null, "practice_team.participants.deletion.actions", "delete")}
        </a>
      )}
    </td>
  </tr>
);

ParticipantItem.propTypes = {
  participantId: PropTypes.string.isRequired,
  participantType: PropTypes.string.isRequired,
  participant: PropTypes.shape({
    firstAndLastName: PropTypes.string.isRequired,
  }),
  onDelete: PropTypes.func,
};

ParticipantItem.displayName = "ParticipantItem";

export default ParticipantItem;
